export class StatusPair {
    statusName: string;
    statusValue: string;

    public constructor(statusName: string, statusValue: string) {
        this.statusName = statusName;
        this.statusValue = statusValue;
    }
}
